import { isMobileDevice } from '../../utils/device'; // Adjust the path as needed

function About() {
    const isMobile = isMobileDevice();

    return <div>
        <header className="bg-indigo-500 text-white py-6">
            <h1 className="text-3xl font-bold text-center">About Sesotho Dictionary Online</h1>
        </header>

        <main className="max-w-4xl mx-auto px-4 py-10 bg-white shadow-lg rounded-lg mt-8">
            <section className="mb-8">
                <p className="text-lg">
                    Welcome to the <strong>Sesotho Dictionary Online Project</strong>, a comprehensive digital initiative dedicated to preserving and enriching the Sesotho language. Our mission is to provide an accessible, user-friendly platform that supports language learners, researchers, and native speakers in exploring and understanding Sesotho.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-green-700 mb-2">Our Mission</h2>
                <p>
                    Our mission is to support the learning and everyday use of Sesotho by providing a reliable, user-friendly, and freely accessible dictionary. We believe that language is a powerful tool for cultural preservation and identity, and our goal is to make Sesotho more visible and usable in the digital world.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-green-700 mb-2">What We Offer</h2>
                <ul className="space-y-4">
                    <li className="flex items-start">
                        <span className="text-2xl mr-3">🌍</span>
                        <div>
                            <p className="font-semibold">Comprehensive Lexicon:</p>
                            <p>Explore a rich database of Sesotho words, phrases, and expressions, complete with detailed definitions, pronunciation guides, and usage examples.</p>
                        </div>
                    </li>
                    <li className="flex items-start">
                        <span className="text-2xl mr-3">🔍</span>
                        <div>
                            <p className="font-semibold">Advanced Search Functionality:</p>
                            <p>Easily find specific terms and explore related concepts through our intuitive search functionality.</p>
                        </div>
                    </li>
                    <li className="flex items-start">
                        <span className="text-2xl mr-3">📚</span>
                        <div>
                            <p className="font-semibold">Cultural Insights:</p>
                            <p>Gain a deeper understanding of Sesotho culture and traditions through contextual information and historical notes tied to various terms.</p>
                        </div>
                    </li>
                    <li className="flex items-start">
                        <span className="text-2xl mr-3">💻</span>
                        <div>
                            <p className="font-semibold">User-friendly Interface:</p>
                            <p>Navigate our online platform with ease, whether you're using a computer, tablet, or smartphone.</p>
                        </div>
                    </li>
                </ul>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-green-700 mb-2">Why It Matters</h2>
                <p>
                    As technology advances, many African languages remain underrepresented online. This dictionary is a step toward bridging that gap for Sesotho. Whether you're a student, teacher, traveler, or language enthusiast, this platform is here to help you connect with Sesotho in a meaningful way.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-green-700 mb-2">Get Involved</h2>
                <p className="mb-2">
                    We're continuously improving and expanding our word database. If you'd like to share your thoughts or suggest a new word, please use the <span className="font-semibold">Feedback</span> option in the menu bar.
                </p>
                {!isMobile && (<p>
                    Want to contribute directly? You can request permission through the <span className="font-semibold">Request Access</span> option in the menu. Approved users can help grow the dictionary by adding new entries and updating existing definitions.
                </p>)}
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-green-700 mb-2">Credit</h2>
                <p>
                    This online dictionary is based on a document generously compiled and authored by <strong>MADIELA CHITJA</strong> titled <span className="italic font-medium"><strong>PATLAMANTSOE YA SESOTHO YA MACHABA</strong></span>. His extensive work in documenting and defining Sesotho vocabulary provided the foundation for this digital platform.
                </p>
                <p>
                    We are deeply grateful for his contribution to preserving and promoting the Sesotho language.
                </p>
            </section>

        </main>

        <footer className="text-center text-sm text-gray-500 py-6">
            &copy; 2025 FutureLex - Sesotho Dictionary Online. All rights reserved.
        </footer>
    </div>
}

export default About;